import "./App.css";

import { HashRouter as Router, Route, Routes } from "react-router-dom";
// import Login from "./components/login-register/Login";
// import DashboardHome from "./components/dashboard/DashboardHome";
import { GlobalContextProvider } from "./context/store";
// import DefaultHome from "./components/DefaultHome";
// import ForgotPassword from "./components/login-register/ForgotPassword";
// import ChangePassword from "./components/login-register/ChangePassword";
// import Register from "./components/login-register/Register";

import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-documenteditor/styles/material.css";
import "@syncfusion/ej2-filemanager/styles/material.css";
import "@syncfusion/ej2-grids/styles/material.css";
import "@syncfusion/ej2-lists/styles/material.css";
import "@syncfusion/ej2-material-theme/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-react-base";
import "@syncfusion/ej2-react-filemanager/styles/material.css";
import "@syncfusion/ej2-react-grids/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";

// toast
import "react-toastify/dist/ReactToastify.css";
import { Bounce, ToastContainer } from "react-toastify";
import { registerLicense } from "@syncfusion/ej2-base";
import React, { Suspense } from "react";
import RotateRightIcon from "@mui/icons-material/RotateRight";

// lazy loading

const DefaultHome = React.lazy(() => import("./components/DefaultHome"));

const Login = React.lazy(() => import("./components/login-register/Login"));

const DashboardHome = React.lazy(
  () => import("./components/dashboard/DashboardHome")
);

const ForgotPassword = React.lazy(
  () => import("./components/login-register/ForgotPassword")
);

const ChangePassword = React.lazy(
  () => import("./components/login-register/ChangePassword")
);

const Register = React.lazy(
  () => import("./components/login-register/Register")
);

function App() {
  // Registering Syncfusion license key
  registerLicense(
    "Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXhecnRSR2BfV0RyW0o="
  );

  return (
    <GlobalContextProvider>
      <Router>
        <Suspense
          fallback={
            <div className="flex w-full min-h-dvh justify-center text-center">
              <RotateRightIcon
                className="animate-spin font-bold mx-auto my-auto"
                fontSize="large"
              />
            </div>
          }
        >
          <Routes>
            <Route
              path="/"
              element={
                <Suspense
                  fallback={
                    <div className="flex w-full min-h-dvh justify-center text-center">
                      <RotateRightIcon
                        className="animate-spin font-bold my-auto mx-auto"
                        fontSize="large"
                      />
                    </div>
                  }
                >
                  <DefaultHome />
                </Suspense>
              }
            />
            <Route
              path="/login"
              element={
                <Suspense
                  fallback={
                    <div className="flex w-full min-h-dvh justify-center text-center">
                      <RotateRightIcon
                        className="animate-spin font-bold my-auto mx-auto"
                        fontSize="large"
                      />
                    </div>
                  }
                >
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="/forgot-password"
              element={
                <Suspense
                  fallback={
                    <div className="flex w-full min-h-dvh justify-center text-center">
                      <RotateRightIcon
                        className="animate-spin font-bold my-auto mx-auto"
                        fontSize="large"
                      />
                    </div>
                  }
                >
                  <ForgotPassword />
                </Suspense>
              }
            />
            <Route
              path="/forgot-password/:email"
              element={
                <Suspense
                  fallback={
                    <div className="flex w-full min-h-dvh justify-center text-center">
                      <RotateRightIcon
                        className="animate-spin font-bold my-auto mx-auto"
                        fontSize="large"
                      />
                    </div>
                  }
                >
                  <ChangePassword />
                </Suspense>
              }
            />
            <Route
              path="/register"
              element={
                <Suspense
                  fallback={
                    <div className="flex w-full min-h-dvh justify-center text-center">
                      <RotateRightIcon
                        className="animate-spin font-bold my-auto mx-auto"
                        fontSize="large"
                      />
                    </div>
                  }
                >
                  <Register />
                </Suspense>
              }
            />
            <Route
              path="/*"
              element={
                <Suspense
                  fallback={
                    <div className="flex w-full min-h-dvh justify-center text-center">
                      <RotateRightIcon
                        className="animate-spin font-bold my-auto mx-auto"
                        fontSize="large"
                      />
                    </div>
                  }
                >
                  <DashboardHome />
                </Suspense>
              }
            />
          </Routes>
        </Suspense>
      </Router>

      <ToastContainer
        position={"top-right"}
        autoClose={7000}
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        theme={"dark"}
        transition={Bounce}
      />
    </GlobalContextProvider>
  );
}

export default App;
